import React, { useContext } from 'react'
import { AppContext } from '@state/context'
import {
  COLORS,
  HEADING_TYPE,
  TEXT_SIZES,
  IMAGE_SIZES,
  CONTENT_TYPES,
  USER_ROLES,
  DIVIDER_SIZE,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Image from '@components/Image'
import SubjectHeader from '@components/SubjectHeader'
import { useExamsAllowed } from '@hooks/useExamsAllowed'
import {
  allSectionsCompleted,
  allSectionsPassed,
  anySectionHasExamAttempts,
  anySectionHasExams,
  anySectionHasFailedExam,
  StatusCorner,
} from '@helpers/exams'
import BookProgressButtons from '@components/BookProgressButtons'
import Divider from '@components/Divider'

const SingleBookInfoCard = (props) => {
  const { imageUrl, book, resource } = props
  const { subject, name, sections } = book

  const [state] = useContext(AppContext)
  const {
    app: { userRole, userId },
  } = state

  const examsAllowed = useExamsAllowed()

  const bookHasExams = anySectionHasExams(sections)
  const bookHasAttempts = anySectionHasExamAttempts(sections)
  const bookIsPassed = allSectionsPassed(sections)
  const bookIsFailed = anySectionHasFailedExam(sections)
  const bookIsCompleted = allSectionsCompleted(sections)

  const getStatusCorner = () => {
    if (!bookHasExams) return null

    if (bookIsPassed) {
      return <StatusCorner passed={true} size='small' />
    } else {
      if (bookIsCompleted) {
        if (bookIsFailed) {
          return <StatusCorner passed={false} size='small' />
        }
      } else {
        if (bookHasAttempts) {
          return <StatusCorner size='small' />
        }
      }
    }
  }

  return (
    <>
      <div className={'relative flex bg-black p-3'}>
        {examsAllowed && userRole === USER_ROLES.STUDENT && (
          <>{getStatusCorner()}</>
        )}

        {imageUrl && (
          <div className={'h-[92px] w-[92px] mr-4'}>
            <Image imageUrl={imageUrl} />
          </div>
        )}
        <div className={'flex flex-col justify-between'}>
          <div>
            <SubjectHeader subject={subject} type={CONTENT_TYPES.BOOK} />
            <Heading
              headingLevel={HEADING_TYPE.H2}
              size={TEXT_SIZES.BASE}
              color={COLORS.WHITE.TEXT}
            >
              {name}
            </Heading>
          </div>

          <div>
            {resource && bookHasExams && (
              <BookProgressButtons book={book} resource={resource} />
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default SingleBookInfoCard
